// import { getLogger } from 'utils/logger';

import { createSelector } from 'reselect';
import { List } from 'immutable';
import { REDUCER_KEY } from './reducer';
// const log = getLogger('data/tags/selector.js');

export const getTagsStore = (state) => state[REDUCER_KEY];
export const getLastSyncDate = (state: any) => getTagsStore(state).lastSyncDate;

export const getTags = (state) => getTagsStore(state).resourcesById;

export const getTagsListObject = createSelector(
  getTags,
  (tags) => {
    if (!tags) {
      return new List([]);
    }
    let data = new List();
    tags.forEach((tag) => {
      data = data.withMutations((list) => {
        list.push({ id: tag.id, name: tag.name });
        return list;
      });
    });
    return data;
  }
);

export const getTagsIsLoading = (state) => getTagsStore(state).isLoading;

export function getTagById(state, id) {
  if (state.resourcesById) {
    return state.resourcesById.get(id) || null;
  }
  return null;
}

export function getTagByName(state, name) {
  if (state.resourcesById) {
    return state.resourcesById.find((x) => x.name === name) || null;
  }
  return null;
}
